import React from "react";
import PropTypes from "prop-types";
import {
  FormControlLabel, 
  Switch,
} from "@mui/material";

class ToggleOnOff extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { value } = this.props;
    return (
      <FormControlLabel
        control={
          <Switch 
            checked={value}
            onChange={this.props.onClick}
          />
        }
        label={this.props.label}
      />
    );
  }
}

export default ToggleOnOff;
